/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'more': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#393B3E" d="M6.869 12.525L11.394 8 6.87 3.475 8 2.343 13.657 8 8 13.657z" fill-rule="nonzero"/>'
  }
})
